/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Smarts Conversation UI
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
export const BATCH_SIZE = 32
export const EPOCHS = 1000
export const MIN_NN_SIZE = 16
export const MAX_NN_SIZE = 1024
export const DEFAULT_DENSE_LAYERS = { nnSizeFactor: 2, activation: 'relu' }
export const LEARNING_RATE = 0.005
export const TRAIN_VAL_RATIO = 0.25